// extracted by mini-css-extract-plugin
module.exports = {"attention":"styles_attention__1A00K","note":"styles_note__1XcO4"};